import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axiosInstance';

// Define an async thunk to fetch data from the API

export const userLoginApi = createAsyncThunk(
  'login/userLoginApi',
  async ({ email, password }, { rejectWithValue }) => { // Accept email and password as arguments
    try {
      const response = await axiosInstance.post('/auth/login/', { // Use POST to send data
        email: email,
        password: password,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const userForgotPasswordApi = createAsyncThunk(
  'login/userForgotPasswordApi',
  async ({ email, otp_type }, { rejectWithValue }) => { // Accept email and password as arguments
    try {
      const response = await axiosInstance.post('/auth/forgotpassword/', { // Use POST to send data
        email: email,
        otp_type: otp_type,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const userOtpVerificationApi = createAsyncThunk(
  'login/userOtpVerificationApi',
  async ({ otp, otp_type, user_id, new_password }, { rejectWithValue }) => { // Accept email and password as arguments
    try {
      const response = await axiosInstance.post('/auth/verify-otp/', { // Use POST to send data
        otp: otp,
        otp_type: otp_type,
        user_id: user_id,
        new_password: new_password
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const userResendOtpApi = createAsyncThunk(
  'login/userResendOtpApi',
  async ({ otp_type, user_id }, { rejectWithValue }) => { // Accept email and password as arguments
    try {
      const response = await axiosInstance.post('/auth/resend-otp/', { // Use POST to send data
        user_id: user_id,
        otp_type: otp_type,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const userResetPasswordApi = createAsyncThunk(
  'login/userResetPasswordApi',
  async ({ email, new_password }, { rejectWithValue }) => { // Accept email and password as arguments
    try {
      const response = await axiosInstance.post('/auth/resetpassword/', { // Use POST to send data
        email: email,
        new_password: new_password
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);